import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { RestServices } from '../../../../services/rest.services'
import { AuthService } from '../../../../services/auth.services'
import { imageUrl } from '../../../../../helper/common'
import { MatrixServices } from '../../../../services/image/matrix.services'

@Component({
    selector: 'app-top-communication',
    templateUrl: './top-communication.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './top-communication.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class TopCommunicationComponent implements OnInit {
    arrTop
    baseUrl = imageUrl

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, public matrixServices: MatrixServices) {
        this.listTop()
        this.matrixServices.styleMatrix = []
    }

    ngOnInit() {
    }

    // list staff
    listTop() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
                room: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    this.arrTop = success['response']['room']['paths']['{}']
                    if (typeof this.arrTop !== 'undefined' && this.arrTop.length > 0) {
                        this.arrTop.forEach(room => {
                            if (typeof room.title !== 'undefined' && room.title.length > 10) {
                                room.titleFull = room.title
                                room.title = room.title.substring(0, 10) + '...'
                            }
                        });
                    }
                },
            )
        })
    }

    selectRoom(id) {
        this.router.navigateByUrl('/app/main/communication/room/' + id + '/home')
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication/top-communication/top-communication.component.ts